import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'product-description-slice',
  templateUrl: './product-description-slice.component.html',
  styleUrls: ['./product-description-slice.component.scss']
})
export class ProductDescriptionSliceComponent implements AfterViewInit {
  @Input() public text: string = '';
  @Input() public lines: number = 2;

  @ViewChild('textContent', { static: false }) textContentRef: ElementRef | undefined;

  public expand: boolean = false;
  public isOverflow: boolean = false;

  ngAfterViewInit() {
    setTimeout(() => this.updateRenderedOverflow());
  }

  public showMore() {
    this.expand = true;
  }

  public showLess() {
    this.expand = false;
  }

  private updateRenderedOverflow() {
    if (!this.lines || !this.textContentRef || this.expand) {
      return;
    }

    const el = this.textContentRef.nativeElement;
    this.isOverflow = el.scrollHeight > el.clientHeight + 1;
  }
}
